// A'gong CTA — scroll-triggered entrance animations
document.addEventListener('DOMContentLoaded', function () {
  if (!document.querySelector('[data-agong-cta]')) return;

  if (!window.IntersectionObserver) {
    document.querySelectorAll('[data-agong-cta-anim]').forEach(function (el) {
      el.classList.add('is-visible');
    });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.2 });

  document.querySelectorAll('[data-agong-cta-anim]').forEach(function (el) {
    observer.observe(el);
  });
});
